import React, { useState, useEffect } from 'react';
import { BarChart3, Calendar, CheckCircle, Clock, TrendingUp, User } from 'lucide-react';
import Role from '../../Data/Role';
import './TaskTooltip.css';

const TaskTooltip = ({ userId, isVisible, position, Get, Url }) => {
    console.log('userId in TaskTooltip:', userId);

    const [taskData, setTaskData] = useState({
        completedOpYearJobs: 0,
        currentOpYearJobs: 0,
        completedOpMonthJobs: 0,
        currentOpMonthJobs: 0
    });
    const [loading, setLoading] = useState(false);
    const [viewType, setViewType] = useState('yearly');

    const load = () => {
        const actualUserId = userId?.userId || userId;

        if (!actualUserId) {
            console.error('No user ID provided');
            return;
        }

        setLoading(true);

        Get(Url.staffByrole(Role.operation))
            .then((resp) => {
                console.log('All operations staff:', resp);

                const userData = resp.find(user => user.id === actualUserId);

                if (userData) {
                    console.log('Found user data:', userData);
                    setTaskData({
                        completedOpYearJobs: userData.completedOpYearJobs || 0,
                        currentOpYearJobs: userData.currentOpYearJobs || 0,
                        completedOpMonthJobs: userData.completedOpMonthJobs || 0,
                        currentOpMonthJobs: userData.currentOpMonthJobs || 0
                    });
                } else {
                    console.warn('User not found in operations staff list');
                    setTaskData({
                        completedOpYearJobs: 0,
                        currentOpYearJobs: 0,
                        completedOpMonthJobs: 0,
                        currentOpMonthJobs: 0
                    });
                }
            })
            .catch((error) => {
                console.error('Error loading user tasks:', error);
                setTaskData({
                    completedOpYearJobs: 0,
                    currentOpYearJobs: 0,
                    completedOpMonthJobs: 0,
                    currentOpMonthJobs: 0
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (isVisible && userId) {
            load();
        }
    }, [isVisible, userId]);

    if (!isVisible) return null;

    const getTooltipPosition = () => {
        const tooltipWidth = 320; // Your modal width
        const screenWidth = window.innerWidth;
        const margin = 10; // Minimum margin from screen edges

        let left = position.x - (tooltipWidth / 2); // Center the tooltip on cursor
        let top = position.y + 10;

        // Adjust if tooltip goes off the right edge
        if (left + tooltipWidth > screenWidth - margin) {
            left = screenWidth - tooltipWidth - margin;
        }

        // Adjust if tooltip goes off the left edge
        if (left < margin) {
            left = margin;
        }


        const tooltipHeight = 400;
        if (top + tooltipHeight > window.innerHeight - margin) {
            top = position.y - tooltipHeight - 10; // Show above cursor instead
        }

        return { left, top };
    };

    const getCurrentData = () => {
        if (viewType === 'yearly') {
            return {
                completed: taskData.completedOpYearJobs,
                current: taskData.currentOpYearJobs,
                period: 'This Year'
            };
        } else {
            return {
                completed: taskData.completedOpMonthJobs,
                current: taskData.currentOpMonthJobs,
                period: 'This Month'
            };
        }
    };

    const { completed, current, period } = getCurrentData();
    const total = completed + current;
    const completionRate = total > 0 ? Math.round((completed / total) * 100) : 0;

    const tooltipPosition = getTooltipPosition();

    return (
        <div className="task-tooltip-overlay">
            <div
                className="task-hover-modal"
                style={{
                    left: tooltipPosition.left,
                    top: tooltipPosition.top
                }}
            >

                <div className="modal-header">
                    <h4>
                        <BarChart3 size={20} className="header-icon" />
                        Task Overview
                    </h4>

                </div>


                <div className="view-toggle">
                    <div className="toggle-container">
                        <button
                            onClick={() => setViewType('yearly')}
                            className={`toggle-button ${viewType === 'yearly' ? 'active' : ''}`}
                        >
                            <Calendar size={14} className="toggle-icon" />
                            Yearly
                        </button>
                        <button
                            onClick={() => setViewType('monthly')}
                            className={`toggle-button ${viewType === 'monthly' ? 'active' : ''}`}
                        >
                            <TrendingUp size={14} className="toggle-icon" />
                            Monthly
                        </button>
                    </div>
                </div>

                {loading ? (
                    <div className="loading-state">
                        <div className="loading-spinner"></div>
                        <span>Loading tasks...</span>
                    </div>
                ) : (
                    <div className="modal-content">

                        <div className="period-label">
                            <span>{period}</span>
                        </div>


                        <div className="main-stats">
                            <div className="stat-card total">
                                <div className="stat-number">{total}</div>
                                <div className="stat-label">Total Tasks</div>
                            </div>
                            <div className="stat-card completion">
                                <div className="stat-number">{completionRate}%</div>
                                <div className="stat-label">Completion Rate</div>
                            </div>
                        </div>


                        <div className="task-breakdown">
                            <div className="breakdown-item current">
                                <div className="breakdown-left">
                                    <div className="breakdown-icon-container">
                                        <Clock size={16} className="breakdown-icon" />
                                    </div>
                                    <div className="breakdown-info">
                                        <div className="breakdown-title">Current Jobs</div>
                                        <div className="breakdown-subtitle">In Progress</div>
                                    </div>
                                </div>
                                <div className="breakdown-count">{current}</div>
                            </div>

                            <div className="breakdown-item completed">
                                <div className="breakdown-left">
                                    <div className="breakdown-icon-container">
                                        <CheckCircle size={16} className="breakdown-icon" />
                                    </div>
                                    <div className="breakdown-info">
                                        <div className="breakdown-title">Completed</div>
                                        <div className="breakdown-subtitle">Finished</div>
                                    </div>
                                </div>
                                <div className="breakdown-count">{completed}</div>
                            </div>
                        </div>



                    </div>
                )}

                <div className="tooltip-arrow"></div>
            </div>
        </div>
    );
};

export default TaskTooltip;